import { endOfYear, format, startOfYear } from "date-fns";

export function yearToPeriod(year) {
  const anchor = new Date(year, 0, 1);
  return {
    periodType: "year",
    from: format(startOfYear(anchor), "yyyy-MM-dd"),
    to: format(endOfYear(anchor), "yyyy-MM-dd"),
  };
}

export function yearFromPeriod(period) {
  if (period?.from) return new Date(period.from).getFullYear();
  return new Date().getFullYear();
}
